const DEFAULT_PASSWORD_MIN_LENGTH = 12;

export function normalizeAuthConfig(config = {}) {
  const auth = config.auth && typeof config.auth === 'object' ? config.auth : {};
  const providers = auth.providers && typeof auth.providers === 'object' ? auth.providers : {};
  const requestedLength = Number(auth.passwordMinLength);
  const passwordMinLength = Number.isFinite(requestedLength)
    ? Math.min(64, Math.max(8, Math.trunc(requestedLength)))
    : DEFAULT_PASSWORD_MIN_LENGTH;

  return {
    emailSignupEnabled: auth.emailSignupEnabled !== false,
    passwordMinLength,
    providers: {
      google: providers.google === true,
      microsoft: providers.microsoft === true
    }
  };
}

export function validateNewPassword(password, minimumLength = DEFAULT_PASSWORD_MIN_LENGTH) {
  if (typeof password !== 'string' || password.length < minimumLength) {
    return { valid: false, message: `يجب أن تتكون كلمة المرور من ${minimumLength} حرفاً على الأقل` };
  }
  return { valid: true, message: '' };
}

export function friendlyAuthError(error) {
  const original = String(error?.message || '');
  const message = original.toLowerCase();
  if (message.includes('invalid login credentials')) return 'بيانات الدخول غير صحيحة';
  if (message.includes('already registered') || message.includes('user already registered')) return 'البريد مستخدم بالفعل';
  if (message.includes('password') && (message.includes('weak') || message.includes('least'))) return 'اختر كلمة مرور أقوى';
  if (message.includes('email not confirmed')) return 'تحقق من بريدك لتأكيد الحساب';
  if (message.includes('expired') || message.includes('invalid') && message.includes('token')) return 'الرابط غير صالح أو انتهت صلاحيته';
  if (message.includes('rate limit')) return 'تم إرسال طلبات كثيرة. حاول مرة أخرى لاحقاً';
  return original || 'تعذر إكمال العملية';
}
